// src/utils/downloader.js
// import { window.electronAPI.invoke } from 'electron'

class FileDownloader {
    constructor() {
        console.log('FileDownloader-constructor')
        this.downloadTasks = new Map()
        this.downloadSpeeds = new Map()
        this.downloadCover=false
        this.setupListeners()
    }

    /**
     * 设置IPC监听器
     */
    setupListeners() {
		if(!window.electronAPI)return;
        // 下载进度监听
        window.electronAPI.receive('download-progress', (data) => {
            this.updateSpeed(data.downloadId, data.receivedBytes)
            const task = this.downloadTasks.get(data.downloadId)
            if (task && task.onProgress) {
                const speed = this.calculateSpeed(data.downloadId)
                const timeRemaining = this.calculateTimeRemaining(
                    data.receivedBytes,
                    data.totalBytes,
                    speed
                )

                task.onProgress({
                    ...data,
                    speed,
                    timeRemaining
                })
            }
        })

        // 下载完成监听
        window.electronAPI.receive('download-completed', (data) => {
            const task = this.downloadTasks.get(data.downloadId)
            console.log('download-completed', data)
            if (task && task.onComplete) {
                task.onComplete(data)
            }
            this.cleanupDownload(data.downloadId)
        })

        // 下载错误监听
        window.electronAPI.receive('download-error', (data) => {
            const task = this.downloadTasks.get(data.downloadId)
            if (task && task.onError) {
                task.onError(data)
            }
            this.cleanupDownload(data.downloadId)
        })

        // 下载开始监听
        window.electronAPI.receive('download-started', (data) => {
            const task = this.downloadTasks.get(data.downloadId)
            if (task && task.onStart) {
                task.onStart(data)
            }
        })

        // 下载暂停监听
        window.electronAPI.receive('download-paused', (data) => {
            const task = this.downloadTasks.get(data.downloadId)
            if (task && task.onPause) {
                task.onPause(data)
            }
            this.cleanupDownload(data.downloadId)
        })

        // 下载取消监听
        window.electronAPI.receive('download-cancelled', (data) => {
            const task = this.downloadTasks.get(data.downloadId)
            if (task && task.onCancel) {
                task.onCancel(data)
            }
            this.cleanupDownload(data.downloadId)
        })
    }

    /**
     * 开始下载文件
     */
    async download(options) {
        try {
            // 获取下载目录
            const downloadDir = await window.electronAPI.invoke('get-app-temp-file-path', {
                name: options.fileName,
                fileType: options.fileType
            })
            // 发送下载请求到主进程
            const downloadId = await window.electronAPI.invoke('download-file', {
                url: options.url,
                filePath: downloadDir,
                fileName: options.fileName,
                headers: options.headers || {}
            })
            if (downloadId) {
                this.downloadTasks.set(downloadId, options)
                this.downloadSpeeds.set(downloadId, [])
                return downloadId
            }

            return null
        } catch (error) {
            console.error('下载启动失败:', error)
            if (options.onError) {
                options.onError({
                    downloadId: '',
                    error: error.message,
                    filePath: ''
                })
            }
            return null
        }
    }

    /**
     * 暂停下载
     */
    async pauseDownload(downloadId) {
        if (this.downloadTasks.has(downloadId)) {
            await window.electronAPI.invoke('pause-download', downloadId)
        }
    }

    /**
     * 取消下载
     */
    async cancelDownload(downloadId) {
        if (this.downloadTasks.has(downloadId)) {
            await window.electronAPI.invoke('cancel-download', downloadId)
        }
    }

    /**
     * 获取默认下载路径
     */
    async getDefaultDownloadPath() {
        return await window.electronAPI.invoke('get-download-path')
    }

    /**
     * 获取下载历史
     */
    async getDownloadHistory() {
        return await window.electronAPI.invoke('get-download-history')
    }

    /**
     * 清除下载历史
     */
    async clearDownloadHistory() {
        return await window.electronAPI.invoke('clear-download-history')
    }

    /**
     * 打开文件
     */
    async openFile(filePath) {
        return await window.electronAPI.invoke('open-file', filePath)
    }

    /**
     * 在文件夹中显示文件
     */
    async showInFolder(filePath) {
        return await window.electronAPI.invoke('show-in-folder', filePath)
    }

    /**
     * 更新下载速度数据
     */
    updateSpeed(downloadId, bytes) {
        const now = Date.now()
        const speedData = this.downloadSpeeds.get(downloadId) || []

        speedData.push({bytes, time: now})

        // 只保留最近5秒的数据
        const fiveSecondsAgo = now - 5000
        const filteredData = speedData.filter(item => item.time > fiveSecondsAgo)

        this.downloadSpeeds.set(downloadId, filteredData)
    }

    /**
     * 计算下载速度（字节/秒）
     */
    calculateSpeed(downloadId) {
        const speedData = this.downloadSpeeds.get(downloadId)
        if (!speedData || speedData.length < 2) {
            return 0
        }

        const first = speedData[0]
        const last = speedData[speedData.length - 1]
        const timeDiff = (last.time - first.time) / 1000

        if (timeDiff <= 0) {
            return 0
        }

        const bytesDiff = last.bytes - first.bytes
        return bytesDiff / timeDiff
    }

    /**
     * 计算剩余时间（秒）
     */
    calculateTimeRemaining(receivedBytes, totalBytes, speed) {
        if (totalBytes <= 0 || speed <= 0) {
            return -1 // 未知
        }

        const remainingBytes = totalBytes - receivedBytes
        return Math.ceil(remainingBytes / speed)
    }

    /**
     * 清理下载任务
     */
    cleanupDownload(downloadId) {
        this.downloadTasks.delete(downloadId)
        this.downloadSpeeds.delete(downloadId)
    }

    /**
     * 格式化字节数为可读字符串
     */
    static formatBytes(bytes) {
        if (bytes === 0) return '0 Bytes'

        const k = 1024
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    }

    /**
     * 格式化时间为可读字符串
     */
    static formatTimeRemaining(seconds) {
        if (seconds < 0) return '未知'
        if (seconds < 60) return `${Math.ceil(seconds)}秒`
        if (seconds < 3600) return `${Math.floor(seconds / 60)}分${Math.ceil(seconds % 60)}秒`

        const hours = Math.floor(seconds / 3600)
        const minutes = Math.floor((seconds % 3600) / 60)
        return `${hours}时${minutes}分`
    }

    /**
     * 批量下载
     */
    async downloadMultiple(urls, options = {}) {
        console.log('downloadMultiple',urls,options)
        const results = []
        const onItemProgress = options.onItemProgress
        const onAllComplete = options.onAllComplete
        const concurrency = options.concurrency || 3

        // 实现并发控制
        const downloadQueue = []
        let activeDownloads = 0
        let completed = 0

        return new Promise((resolve) => {
            const processNext = () => {
                if (downloadQueue.length === 0 && activeDownloads === 0) {
                    console.log('processNext',results)
                    if (onAllComplete) {
                        onAllComplete(results)
                    }
                    resolve(results)
                    return
                }

                while (activeDownloads < concurrency && downloadQueue.length > 0) {
                    activeDownloads++
                    const {url, itemOptions} = downloadQueue.shift()
                    console.log('activeDownloads',url,itemOptions)
                    this.download({
                        url,
                        ...itemOptions,
                        onProgress: (progress) => {
                            if (onItemProgress) {
                                console.log('222',itemOptions.type)
                                onItemProgress(itemOptions.type,url, progress)
                            }
                        },
                        onComplete: (result) => {
                            result.type=itemOptions.type
                            console.log('onComplete',results)
                            results.push(result)
                            completed++
                            activeDownloads--
                            processNext()
                        },
                        onError: (error) => {
                            activeDownloads--
                            processNext()
                        }
                    })
                }
            }

            // 将URL添加到队列
            urls.forEach((urlObj, index) => {
                console.log('------',urlObj)
                let url=urlObj.url
                const itemOptions = {
                    fileName: url.substring(url.lastIndexOf('/')),
                    headers: options.headers,
                    url:url,
                    fileType:options.fileType,
                    type:urlObj.type

                }
                downloadQueue.push({url, itemOptions})
            })

            processNext()
        })
    }
}

// 导出单例实例
export const downloader = new FileDownloader()
export default downloader